import { render, staticRenderFns } from "./UserFeedBackDetail.vue?vue&type=template&id=dfd8fea0&scoped=true"
import script from "./UserFeedBackDetail.vue?vue&type=script&lang=ts"
export * from "./UserFeedBackDetail.vue?vue&type=script&lang=ts"
import style0 from "./UserFeedBackDetail.vue?vue&type=style&index=0&id=dfd8fea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8fea0",
  null
  
)

export default component.exports